import {
  useGetBillablePercentageForHomeWidget,
  GET_BILLABLE_PERCENTAGE_KEY,
} from '@legacy/apis/billablePercentageAPI';
import WidgetWithoutChart from '../WidgetWithoutChart';

export const BillablePercentageWidget = () => {
  const {
    isError: isBillablePercentageError,
    isLoading: isBillablePercentageLoading,
    informationList: billablePercentageInformationList,
  } = useGetBillablePercentageForHomeWidget();

  return (
    <WidgetWithoutChart
      queryKey={GET_BILLABLE_PERCENTAGE_KEY}
      relId="BillablePercentage"
      informationList={billablePercentageInformationList}
      isError={isBillablePercentageError}
      isLoading={isBillablePercentageLoading}
    />
  );
};
